// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.7.0-LKl0HtBlpKLwpmTQiIJc/mode=imports,min/optimized/keen-slider.js'
const { getElement } = window.BAO.Utils
const { useArrows, setInitialised } = window.BAO.Carousel.plugins

class LoyaltyTierOverview extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slider']
  }

  connectedCallback () {
    super.connectedCallback()

    const slider = this.els.slider.element
    if (slider) {
      this.carousel = this.initialiseCarousel(slider)
    }
  }

  initialiseCarousel (slider) {
    return new KeenSlider(
      slider,
      {
        slides: {
          loop: false,
          mode: 'snap',
          rtl: false,
          perView: 'auto',
          spacing: 10,
          origin: 'center',
        },
        initial: parseInt(this.dataset.initial),
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              origin: 'auto',
              perView: 'auto',
              spacing: 10,
            },
          },
        },
      },
      [
        carousel => {
          carousel.on('animationStarted', () => {
            const nextActiveIndex = carousel.track.absToRel(
              carousel.animator.targetIdx || 0,
            )

            carousel.slides.forEach((slide, index) => {
              slide.setAttribute('aria-current', index === nextActiveIndex)
            })

            this.activeIndex = nextActiveIndex
          })
        },
        setInitialised(),
        useArrows({
          next: getElement('.ll-TierOverview_Control-next', {
            context: slider.parentElement,
          }),
          previous: getElement('.ll-TierOverview_Control-previous', {
            context: slider.parentElement,
          }),
        }),
      ],
    )
  }
}

if (!customElements.get('loyalty-tier-overview')) {
  customElements.define('loyalty-tier-overview', LoyaltyTierOverview)
}
